import React from 'react';
import { motion } from 'framer-motion';

function LoadingScreen() {
  return (
    <motion.div
      initial={{ opacity: 1 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.3 }}
      className="fixed inset-0 z-50 flex items-center justify-center bg-gradient-to-br from-slate-50 via-rose-50/30 to-slate-50 dark:from-slate-900 dark:via-slate-800 dark:to-slate-900"
    >
      <div className="text-center">
        {/* 🚀 簡化動畫 - 更快顯示 */}
        <motion.div
          className="relative mx-auto mb-6"
          animate={{
            scale: [1, 1.05, 1],
          }}
          transition={{
            duration: 1.5,
            repeat: Infinity,
            ease: "easeInOut"
          }}
        >
          <div className="w-16 h-16 mx-auto">
            <motion.div
              className="relative w-full h-full"
              animate={{ rotate: 360 }}
              transition={{ duration: 2, repeat: Infinity, ease: "linear" }}
            >
              <div className="absolute inset-0 rounded-full bg-gradient-to-br from-rose-400 via-pink-400 to-orange-400 opacity-20 blur-xl"></div>
            </motion.div>
            
            <div className="absolute inset-0 flex items-center justify-center">
              <motion.div
                className="relative w-12 h-8"
                animate={{ y: [0, -3, 0] }}
                transition={{ duration: 1.2, repeat: Infinity, ease: "easeInOut" }}
              >
                {/* Rice */}
                <div className="absolute bottom-0 left-0 w-full h-4 bg-gradient-to-br from-orange-50 via-yellow-50 to-amber-50 rounded-sm border border-orange-200/60 shadow-md"></div>
                {/* Fish */}
                <div className="absolute top-0 left-0 w-full h-5 bg-gradient-to-br from-red-400 via-orange-400 to-pink-400 rounded-sm shadow-lg border border-red-300/40"></div>
              </motion.div>
            </div>
          </div>
        </motion.div>

        {/* Loading Text - 立即顯示 */}
        <div>
          <h2 className="text-xl font-bold text-slate-900 dark:text-white mb-2">
            正在準備中
          </h2>
          <p className="text-slate-600 dark:text-slate-400 text-sm">
            お待ちください...
          </p>
        </div>

        {/* Loading Dots - 簡化動畫 */}
        <div className="flex items-center justify-center gap-2 mt-4">
          {[0, 1, 2].map((i) => (
            <motion.div
              key={i}
              className="w-2 h-2 bg-rose-500 rounded-full"
              animate={{
                scale: [1, 1.3, 1],
                opacity: [0.5, 1, 0.5],
              }}
              transition={{
                duration: 1.2,
                repeat: Infinity,
                delay: i * 0.15,
              }}
            />
          ))}
        </div>
      </div>
    </motion.div>
  );
}

export default LoadingScreen;